import React, { Component } from 'react';
import { Route, Switch, Link } from 'react-router-dom'
import './Cover.css'
import Background from './background.jpeg';
import Logo from './banner.jpg';
import ReactGA from 'react-ga'

export const Cover = (props) => {
  ReactGA.pageview(window.location.pathname + window.location.search);
  return (
  <div className="cover-wrapper text-center h-100" style={ { backgroundImage: `url(${Background})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover'} }>

    <div className="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
      <header className="masthead mb-auto">
        <div className="inner">
          <h3 className="masthead-brand">
          </h3>
        </div>
      </header>

      <main role="main" className="inner cover">
        <p className="text-shadow">
          <h4>Sustentabilidade + Rentabilidade</h4>
        </p>
        <h3 className="text-shadow"></h3>
        <br/>
        <h1 className="display-4 text-shadow">Ferramenta de Auto-Diagnóstico</h1>
        <br/>
        <p className="text-shadow">Mapeie o que já faz. Perceba o que pode fazer mais.</p>
        <p>
          <br/>
        </p>
        <p className="lead">
          <Link to="/register" className="btn btn-lg btn-secondary">
            Iniciar
          </Link>
        </p>
      </main>

      <footer className="mastfoot mt-auto">
        <div className="inner">
          <img src={Logo} height="80px" style={{borderRadius: '0.25em'}}/>
        </div>
      </footer>
    </div>
</div>
)
}





// WEBPACK FOOTER //
// ./src/Cover.jsx